export default __webpack_public_path__ + "static/media/AyoubBelkas.ab655af5.webp";